import { render } from "./EstadoCivil_Persona.vue?vue&type=template&id=82203736"
import script from "./EstadoCivil_Persona.vue?vue&type=script&lang=js"
export * from "./EstadoCivil_Persona.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__